/*** Importations ******************************************************************************/

// Polyfills

import 'mdn-polyfills/NodeList.prototype.forEach';
import 'mdn-polyfills/Element.prototype.matches';
import 'mdn-polyfills/Element.prototype.closest';
import 'mdn-polyfills/CustomEvent';
import 'mdn-polyfills/Node.prototype.prepend';
import 'mdn-polyfills/Node.prototype.append';

import 'classlist-polyfill';
import 'unfetch/polyfill';
//import focusWithin from 'focus-within-polyfill/src/focus-within.js';
import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';
import smoothscroll from 'smoothscroll-polyfill';

// Libraries

import InfiniteScroll from 'infinite-scroll';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
import * as basicLightbox from 'basiclightbox/src/scripts/main.js';
import { tns } from 'tiny-slider/src/tiny-slider.module.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock/lib/bodyScrollLock.es6.js';
import { CountUp } from 'countup.js';

// Particles.js est incompatible avec le mode strict. Il est enqueué dans Bones.

// Scripts Nubee

import * as functions from 'partials/functions.js';
import GoogleMap from 'partials/google-map.js';
// import MobileMenu from 'partials/mobile-menu.js';
import PageMenu from 'partials/page-menu.js';
// import toggleSearchForm from 'partials/toggle-search-form.js';
import imgCheck from 'partials/img-check.js';
// import AjaxPopup from 'partials/ajax-popup.js';
import NubeeLightbox from 'partials/nubee-lightbox.js';
import placeholderLabelUpdate from 'partials/placeholder-label.js';
import FormValidation from 'partials/form-validation.js';
// import SwipeFinger from 'partials/swipe-finger.js';

import * as cookiesBar from 'partials/cookies-bar.js';

(function() {
	/*** Application des polyfills *****************************************************************/

	(function() {
		objectFitImages();
		smoothscroll.polyfill();

		if( 'function' != typeof window.Event ) {
			window.Event = CustomEvent;
		}
	}) ();


	/*** Variables globales ************************************************************************/

	window.vWidth = document.documentElement.clientWidth;
	window.vHeight = document.documentElement.clientHeight;

	window.slider = 'tiny';

	if( window.vWidth >= 800 ) {
		let pageMenuEl = document.querySelector('.page-menu');
		window.fixedElHeight = pageMenuEl ? pageMenuEl.clientHeight : 0;
	} else {
		window.fixedElHeight = 0;
	}

	window.fixedElWidth = 0;

	window.vWidthExceptFixed = document.documentElement.clientWidth - fixedElWidth;
	window.vHeightExceptFixed = window.vHeight - fixedElHeight;
	window.curScroll = {
		top: document.documentElement.scrollTop || document.body.scrollTop || 0,
		left: document.documentElement.scrollLeft || document.body.scrollLeft || 0,
		topExceptFixed: ( document.documentElement.scrollTop || document.body.scrollTop || 0 ) + window.fixedElHeight,
		leftExceptFixed: ( document.documentElement.scrollLeft || document.body.scrollLeft || 0 ) + window.fixedElWidth,
	};
	window.vCenter = {
		x: window.curScroll.left + ( window.vWidth / 2 ),
		y: window.curScroll.top + ( window.vHeight / 2 ),
		xExceptFixed: window.curScroll.left + ( window.vWidthExceptFixed / 2 ),
		yExceptFixed: window.curScroll.top + ( window.vHeightExceptFixed / 2 ),
	};
	window.ga = window.ga || window._gaq || null;
	window.lastWindowOpened = 0;

	// countUp

	window.countUpNumbers = Array.prototype.slice.call( document.querySelectorAll( '.countup-number' ) );
	window.countUpInstances = [];

	// Smooth-animate
	window.smoothElements = document.querySelectorAll('.smooth-animate');

	// Chaîne traduisible : window.bonesGlobals.i18n.monPlugin.nomDeChaine


	/*** Mise à jour des mesures de l'écran au resize *********************************************/

	window.addEventListener( 'resize', function() {
		window.vWidth = document.documentElement.clientWidth;
		window.vHeight = document.documentElement.clientHeight;
		window.curScroll.top = document.documentElement.scrollTop || document.body.scrollTop;
		window.vCenter.y = window.curScroll.top + ( window.vHeight / 2 );
	} );


	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres ****************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');

		linksWithHash.forEach( function( thisLink ) {
			if( functions.urlsAreSamePage({ urls: [ thisLink.href, window.location.href ] }) ) {
				thisLink.href = thisLink.hash;
			}
		} );
	}) ();


	/*** Défiler doucement les liens ancres ****************************************************************/
	// Requiert la fonction functions.smoothScrollTo
	// Ajuster la variable globale fixedElHeight

	(function() {
		if( 'function' == typeof functions.smoothScrollTo ) {
			document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach( function( thisEl ) {
				thisEl.addEventListener( 'click', function( event ) {
					if( 1 == event.which && ! this.classList.contains('no-smooth-scroll') ) {
						let theHash;

						event.preventDefault();
						theHash = this.getAttribute('href');
						functions.smoothScrollTo( theHash );
					}
				} );
			});
		}
	}) ();


	/*** Ne rien faire au clic sur un lien vide (#) *********************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) ) {
					event.preventDefault();
				}
			}
		} );
	}) ();


	/*** Défiler doucement au chargement d'une URL avec ancre ***********************************************/
	// Requiert la fonction functions.smoothScrollTo

	(function() {
		if( 'function' == typeof functions.smoothScrollTo ) {
			let origHash = window.location.hash;

			if( origHash ) {
				// Blocage du jump du navigateur par défaut
				setTimeout( function() {
					window.location.hash = '';
					functions.removeHash();
				}, 1 )

				window.addEventListener( 'load', function() {
					functions.smoothScrollTo( document.querySelector( origHash ) );
				});
			}

		}
	}) ();


	/*** Images et backgrounds différents selon la taille de l'écran *****************************/
	// Requiert img-check.js

	(function() {
		if( 'function' == typeof imgCheck ) {
			window.addEventListener( 'resize', imgCheck );
			imgCheck();
		}
	}) ();


	/*** Lazy load des images et backgrounds ****************************************************************/
	// Requiert vanilla-lazyload

	(function() {
		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
		});
	}) ();


	/*** Sécurité pour les liens "nouvel onglet" ***********************************************************/


	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which || 2 == event.which ) {
				let linkClicked = event.target.closest('a');
				let linkTarget = linkClicked ? linkClicked.getAttribute('target') : null;
				let newWindow;
				let targetRegex = new RegExp( /^(_blank|_new)$/, 'i' )

				if( linkTarget && targetRegex.test( linkTarget ) ) {
					let linkUrl = linkClicked.getAttribute('href');

					event.preventDefault();
					newWindow = window.open( linkClicked.getAttribute('href'), 'targetBlankWindow_' + window.lastWindowOpened );

					++ window.lastWindowOpened;

					if( newWindow ) {
						newWindow.opener = null;
					}
				}
			}
		} );
	}) ();


	/*** Google Maps ***************************************************************************************/
	// Requiert google-map.js

	(function() {
		let mapParents = document.querySelectorAll('.map-parent');
		let mapStyles = [];

		mapParents.forEach( function( thisParent ) {
			let map = new GoogleMap({
				mapParent: thisParent,
				styles: mapStyles,
			});
		} );
	}) ();


	/*** Antispam maison sur les commentaires *************************************************************/
	// À moins d'avoir activé le JS, la validation PHP refusera le commentaire.

	(function() {
		let commentForms = document.querySelectorAll('#commentform');

		commentForms.forEach( function( thisForm ) {
			thisForm.addEventListener( 'submit', function() {
				let legitInput = document.createElement( 'input' );
				legitInput.setAttribute( 'type', 'hidden' );
				legitInput.setAttribute( 'name', 'is_legit' );
				legitInput.value = 1;

				thisForm.appendChild( legitInput );
			} );
		} );
	}) ();


	/*** Validation de formulaire *************************************************************************/
	(function() {
		document.querySelectorAll( '.validate-form' ).forEach( function( thisForm ) {
			let formValidation = new FormValidation({
				form: thisForm,
			});
		} );
	}) ();


	/*** Placeholder labels - Un placeholder qui se tasse quand on écrit **********************************/
	// Requiert la classe sweet-form sur le formulaire
	// Requiert placeholder-label.js

	(function() {
		document.querySelectorAll('.has-placeholder-label input, .has-placeholder-label textarea').forEach( function( thisEl ) {
			placeholderLabelUpdate( thisEl );

			[ 'load', 'focus', 'blur', 'change', 'input' ].forEach( function( eventName ) {
				thisEl.addEventListener( eventName, placeholderLabelUpdate );
			} );
		} );
	}) ();


	/*** Retour en haut ***********************************************************************************/
	// Requiert functions.smoothScrollTo

	/*(function() {
		document.querySelector('.back-to-top').addEventListener( 'click', function() {
			if( 1 == event.which ) {
				functions.smoothScrollTo( document.body, 0 );
			}
		} );
	}) ();*/


	/*** Menu mobile maison *******************************************************************************/

	/*(function() {
		window.mobileMenu = new MobileMenu({
			menuSel: '.mobile-menu',
			buttonSel: '.mobile-menu-button',
			debug: false,
		});
	}) ();*/

	/*var mobileMenuButton = document.querySelector('.mobile-menu-button'),
		menu = document.querySelector('.mobile-menu'),
		siteHeaderLogo = document.querySelector('.site-header .logo-link');

	mobileMenuButton.addEventListener( 'click', function() {
		mobileMenuButton.classList.toggle('open');
		menu.classList.toggle('open');
		siteHeaderLogo.classList.toggle('hidden');
	});*/

	var mobileMenuButtons = document.querySelectorAll('.mobile-menu-button'),
		menu = document.querySelector('.mobile-menu'),
		menuInner = document.querySelector('.inner-mobile-menu'),
		body = document.querySelector('body');

	for (const mobileMenuButton of mobileMenuButtons) {
		mobileMenuButton.addEventListener( 'click', function() {
			var vWidth = window.vWidth,
				toggleMobileMenuButtons = document.querySelectorAll('.mobile-menu-button');

			body.style.overflowY = 'hidden';
			menuInner.style.overflowY = 'scroll';

			if(mobileMenuButton.classList.contains('open')) {
				menuInner.style.overflowY = 'hidden';
				body.style.overflowY = '';
			}

			for (const toggleMobileMenuButton of toggleMobileMenuButtons) {
				toggleMobileMenuButton.classList.toggle('open');
			}

			menu.classList.toggle('open');
		});
	}

	// À convertir en vanilla js
	/*$('.mobile-menu-button').on('click', function(e){
		e.preventDefault();

		var menu = $('#mobile-menu'),
			menuInner = $('#mobile-menu .inner-mobile-menu'),
			button = $('.mobile-menu-button');

		if( menu.css('display') == 'none' ) {
			$('#mobile-menu').fadeIn(500, function(){
				$('body').css('overflow-y', 'hidden');

				$('#mobile-menu').css( 'overflow-y', 'scroll' );
			});

			menuInner.addClass('open');
			$('.site-gradient').addClass('masked');
			$('.site-container').addClass('masked');
			$('.site-footer').addClass('masked');

			button.each(function(){
				$(this).toggleClass('open');
			});

		} else {
			menuInner.removeClass('open');

			$('body').css('overflow-y', '');
			$('#mobile-menu').css('overflow-y', 'hidden');

			$('#mobile-menu').fadeOut(500);
			$('.site-gradient').removeClass('masked');
			$('.site-container').removeClass('masked');
			$('.site-footer').removeClass('masked');

			button.each(function(){
				$(this).toggleClass('open');
			});
		}
	});*/

	/*** Menu de page à hash qui se met à jour avec le scroll *********************************************/
	// Requiert page-menu.js
	// Ne pas oublier d'appeler window.pageMenu.update() dans le scrollInterval

	(function() {
		window.pageMenu = new PageMenu({
			menuSel: '.page-menu',
		});
	}) ();


	/*** Regroupement d'évènements à intervalles réguliers ************************************************/
	// Plus performant qu'un évènement scroll

	(function() {
		window.scrollInterval = setInterval(function() {
			let lastScroll = window.curScroll;

			window.curScroll = {
				top: document.documentElement.scrollTop || document.body.scrollTop || 0,
				left: document.documentElement.scrollLeft || document.body.scrollLeft || 0,
			};
			window.vCenter = {
				x: window.curScroll.left + ( window.vWidth / 2 ),
				y: window.curScroll.top + ( window.vHeight / 2 ),
			};

			if( window.curScroll.top != lastScroll.top ) {
				/*** Glissement vers le haut et fade-in d'éléments ***/
				// Requiert la fonction functions.smoothFadeIn
				if( 'function' == typeof functions.smoothFadeIn ) {
					functions.smoothFadeIn();
				}

				// Mise à jour des classes active du menu de scroll
				if( window.pageMenu instanceof PageMenu ) {
					window.pageMenu.update();
				}
			}

			// Classes sur le body pour faire changer des CSS en fonction du scroll

			if( window.curScroll.top > 550 ) {
				document.body.classList.add('scrolled-a-lot');
			} else {
				document.body.classList.remove('scrolled-a-lot');
			}

			if( window.curScroll.top > 120 ) {
				document.body.classList.add('scrolled-a-bit');
			} else {
				document.body.classList.remove('scrolled-a-bit');
			}

			// CountUp

			if( 'undefined' != typeof CountUp && 0 < countUpInstances.length ) {
				// console.log(countUpInstances);
				countUpNumbers.forEach( function( element, index, iteratedArray ) {
					if( element && functions.isInViewport(element) ) {
						if( ! countUpInstances[index].error ) {
							element.classList.add( 'countup-counting', 'countup-init' );

							countUpInstances[index].start( function() {
								element.classList.add( 'countup-counted' );
								element.classList.remove( 'countup-counting' );
							} );
						} else {
							console.error( countUpInstances[index].error );
						}

						// On vient de lancer CountUp sur cet élément. On l'enlève de la liste des éléments à traiter.
						iteratedArray[index] = null;
					}
				} );
			}

			window.smoothElements.forEach( function( thisEl ) {
				let offset = vHeight / 8;

				if( thisEl && ( functions.isInViewport( thisEl, offset ) || functions.isHigherThanViewport(thisEl) ) ) {
					thisEl.classList.add( 'show' );
				}
			} );

		}, 100 );
	}) ();


	/*** Recherche qui s'ouvre/ferme en cliquant sur la loupe *********************************************/
	// Requiert toggle-search-form.js

	(function() {
		document.querySelectorAll('.search-form .search-button').forEach( function( thisEl ) {
			thisEl.addEventListener( 'click', function() {
				if( 1 == event.which ) {
					toggleSearchForm( event );
				}
			} );
		} );
	}) ();



	/*** Infinite Scroll - Charger les prochains articles automatiquement *******************************/
	// Requiert jQuery
	// Requiert infinite-scroll.pkgd.min.js

	(function() {
		let infiniteContainers = document.querySelectorAll('.infinite-scroll');

		infiniteContainers.forEach(function( thisEl ) {
			if( thisEl.parentNode.querySelector('.pagination .next') ) {
				let infiniteInstance = new InfiniteScroll(
					'.infinite-scroll',
					{
						path: '.pagination .next',
						append: '.infinite-scroll-element',
						prefill: false,
						history: false,
						// outlayer: outlayer,
						hideNav: '.pagination',
						status: '.infinite-scroll-status',
						debug: false,
					}
				);

				infiniteInstance.on( 'append', function( event, response, path, items ) {
					let loadingEl = thisEl.parentNode.querySelector('.infinite-scroll-status');

					if( loadingEl ) {
						loadingEl.style.display = 'none';
					}

					imgCheck();
					window.siteLazyLoad.update();
				} );
			}
		});
	}) ();


	/*** Dropdown de médias sociaux ***********************************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let buttonClicked = event.target.closest('.more-networks-button');
				let theContainer;
				let theDropdown;

				if( buttonClicked ) {
					let theContainer = buttonClicked.closest( '.more-networks' );
					let theDropdown = theContainer.querySelector( '.more-networks-dropdown' );

					if( ! theContainer.classList.contains('animating') ) {
						theContainer.classList.add( 'animating' );

						if( ! theContainer.classList.contains( 'open' ) ) {
							theContainer.classList.add( 'open' );

							theDropdown.addEventListener( 'transitionend', function fadeInOver( event ) {
								theContainer.classList.remove( 'animating' );
								theDropdown.removeEventListener( 'transitionend', fadeInOver );
							} );

						} else {
							theContainer.classList.remove( 'open' );

							theDropdown.addEventListener( 'transitionend', function fadeOutOver( event ) {
								theContainer.classList.remove( 'animating' );
								theDropdown.removeEventListener( 'transitionend', fadeOutOver );
							} );
						}
					}
				}
			}
		} );
	}) ();


	/*** Sliders Owl Carousel ******************************************************************************/
	// Requiert la fonction functions.initSlider

	// (function() {
	// 	document.querySelectorAll('.slider').forEach( function( thisEl ) {
	// 		functions.initSlider( thisEl );
	// 	} );
	// }) ();



	/*** Sliders Tiny Slider *******************************************************************************/
	// Requiert tns (tiny-slider)

	(function() {
		document.querySelectorAll('.tiny-slider').forEach( function( thisEl ) {
			functions.initSliderTiny( thisEl );
		} );
	}) ();


	/*** Popups AJAX qui changent l'URL ********************************************************************/
	// Requiert ajax-popups.js
	// Requiert nubee-popup.js
	// Requiert basicLightbox
	// Requiert functions.loadingStart
	// Requiert functions.loadingEnd

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest( '.open-ajax-popup' );

				if( linkClicked ) {
					let ajaxPopup;
					event.preventDefault();

					ajaxPopup = new AjaxPopup({
						elementSelector: '.ajax-popup-content',
						ajaxUrl: linkClicked.href,
						// popupClass: '',
						// debug: true,
					});
				}
			}
		} );
	}) ();


	/*** Popups lightbox simples ****************************************************************************/
	// Requiert nubee-lightbox.js
	// Requiert nubee-popup.js
	// Requiert basicLightbox

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest( '.lightbox' );

				if( linkClicked ) {
					event.preventDefault();
					let linkTitle = linkClicked.getAttribute( 'title' );

					let lightboxPopup = new NubeeLightbox({
						items: [
							{
								url: linkClicked.href,
								alt: linkTitle ? linkTitle : null,
							}
						],
						slider: 'owl',
					});
				}
			}
		} );
	}) ();


	/*** Popups lightbox en galeries ************************************************************************/
	// Requiert nubee-lightbox.js
	// Requiert nubee-popup.js
	// Requiert basicLightbox

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest( '.lightbox-gallery-element' );

				if( linkClicked ) {
					let galParent = linkClicked ? linkClicked.closest( '.lightbox-gallery' ) : null;

					if( galParent ) {
						let lightboxLinks = galParent.querySelectorAll( '.lightbox-gallery-element' );
						let lightboxItems = [];
						let startPosition = 0;
						let index = 0;
						let lightboxPopup;

						event.preventDefault();

						lightboxLinks.forEach( function( thisEl ) {
							let linkTitle = thisEl.getAttribute( 'title' );

							lightboxItems.push({
								url: thisEl.href,
								alt: linkTitle ? linkTitle : null,
							});

							if( linkClicked.isSameNode( thisEl ) ) {
								startPosition = index;
							}

							++ index;
						} );

						lightboxPopup = new NubeeLightbox({
							items: lightboxItems,
							slider: 'owl',
							startPosition: startPosition,
						});
					} else {
						console.error("This gallery link doesn't have a .lightbox-gallery parent.");
					}
				}
			}
		} );
	}) ();

	/*** Empêcher la taille d'un élément de se réajuster une fois le chargement terminé ********************/

	(function() {
		window.addEventListener( 'load', function( event ) {
			let lockedHeightEls = document.querySelectorAll('.lock-height-on-load');

			lockedHeightEls.forEach( function( thisEl ) {
				thisEl.style.height = thisEl.offsetHeight + 'px';
				thisEl.style.minHeight = 0;
			} );
		} );
	}) ();


	/*** Polyfill pseudo-sélecteur CSS :focus-within *******************************************************/
	// Requiert focus-within
	// Il ne s'active que si le navigateur ne supporte pas le pseudo-sélecteur.


	/*** Particules : Grille lignes et points animée ********************************************************/

	(function() {
		let scriptFolder = bonesGlobals.themeDir + '/library/js';

		if( document.body.classList.contains( 'page-bg-lines-animated' ) ) {
			particlesJS.load( 'particles-js', scriptFolder + '/data/particles.json', function() {
				// Callback
			});
		}
	}) ();


	/*** Select qui redirigent quand on choisit une option ***************************************************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linkSelects = document.querySelectorAll('.link-select');

		linkSelects.forEach( function( thisSelect ) {
			[ 'change', 'keypress' ].forEach( function( eventName ) {
				thisSelect.addEventListener( eventName, function() {
					let selectedOption = thisSelect.options[ thisSelect.selectedIndex ];
					let targetUrl = selectedOption.dataset.url;

					if( targetUrl && ! functions.urlsAreSamePage({ urls: targetUrl }) ) {
						window.location.href = targetUrl;
					}
				} );
			} );
		} );
	}) ();


	/*** Activation du doigt indicateur de scroll sur les blocs de statistiques appropriés *******************/
	// Requiert swipe-finger.js

	(function() {
		let fingerWrappers = document.querySelectorAll('.swipe-finger-wrapper');
		fingerWrappers.forEach( function( thisWrapper ) {
			let swipeFinger = new SwipeFinger({
				wrapper: thisWrapper,
				debug: true,
			});
		} );
	}) ();


	/*** Animation du logo **********************************************************************************/

	(function() {
		let animatedLogos = document.querySelectorAll('.animated-logo');
		animatedLogos.forEach( function( thisLogo ) {
			setTimeout( function() {
				thisLogo.classList.add('animated-step-1');

				thisLogo.addEventListener( 'transitionend', function animateStep2( event ) {
					thisLogo.removeEventListener( 'transitionend', animateStep2 );

					// Léger délai sinon les 2 étapes se font en même temps
					setTimeout( function() {
						thisLogo.classList.add('animated-step-2' );

						thisLogo.addEventListener( 'transitionend', function animateStep3( event ) {
							thisLogo.removeEventListener( 'transitionend', animateStep3 );

							// Léger délai sinon les 2 étapes se font en même temps
							setTimeout( function() {
								thisLogo.classList.add('animated-step-3' );

								thisLogo.addEventListener( 'transitionend', function animateStep4( event ) {
									thisLogo.classList.add('animated-step-4' );
									thisLogo.removeEventListener( 'transitionend', animateStep4 );
								} );
							}, 10 );
						} );
					}, 10 );
				} );
			}, 400 );
		} );
	}) ();

	/*** Champs ACF file du profile photographe **********************************************************************************/
	(function() {
		document.addEventListener( 'change', function(event) {
			if( event.target.closest('.acf-image-uploader') ) {
				let element = event.target;
				let fileValue = element.value;
				let fileError = 0;
				let wrapper = element.closest('.acf-basic-uploader');

				var errorDivs = element.closest('.acf-image-uploader').querySelectorAll('.acf-error-message');

				if( errorDivs.length > 0 ) {
					errorDivs[0].parentNode.removeChild(errorDivs[0]);
				}

				if( fileValue ) {
					// console.log(fileValue);

					// Vérifier que le fichier n'est pas plus gros que 5 Mo
					for (var i = 0; i <= element.files.length - 1; i++) {
						const fsize = element.files.item(i).size;
						const file = Math.round((fsize / 1024));

						// The size of the file.
						if (file >= 2048) {
							fileError = 1;
							// console.error('Top Condition');
							// alert( "File too Big, please select a file less than 5mb");
						}

						// console.log('round');
					}

					// console.log(fileError);

					if( fileError === 0 ) {

						let startIndex = (fileValue.indexOf('\\') >= 0 ? fileValue.lastIndexOf('\\') : fileValue.lastIndexOf('/'));
						let filename = fileValue.substring(startIndex);

						if(filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
							filename = filename.substring(1);
						}

						if( typeof filename != 'undefined' ) {
							wrapper.setAttribute('data-content', filename);
						} else {
							wrapper.setAttribute('data-content', 'Fichier sélectionné');
						}

						wrapper.classList.add('changed');
					} else {
						// console.error('file too big');
						element.value = '';
						wrapper.setAttribute('data-content', "Choisir une photo");
						element.closest('.acf-image-uploader').innerHTML += '<div class="acf-notice acf-error-message -dismiss -error"><p>Le fichier doit faire moins de 2 Mo</p></div>';
					}
				}
			}
		});
	}) ();

	/*** Défilement de plus de dates dans les single de photographe **********************************************************************************/
	(function() {
		let moreScheduleLink = document.getElementById('more-schedule');
		let scheduleList = document.getElementById('schedule-list');
		let scheduleMoreWrapper = document.getElementById('more-wrapper');

		if( moreScheduleLink !== null && moreScheduleLink !== '' ) {
			let scheduleListHeight = scheduleList.offsetHeight;
			let scheduleMoreWrapperHeight = scheduleMoreWrapper.offsetHeight;

			scheduleList.style.maxHeight = ( scheduleListHeight - scheduleMoreWrapperHeight - 40 ) + 'px';

			moreScheduleLink.addEventListener( 'click', function(event) {
				scheduleList.classList.toggle('active');

				if( scheduleList.classList.contains('active') ) {
					scheduleList.style.maxHeight = ( scheduleListHeight + scheduleMoreWrapperHeight - 40 ) + 'px';
					moreScheduleLink.textContent = window.bonesGlobals.i18n.schedule.less;
				} else {
					scheduleList.style.maxHeight = ( scheduleListHeight - scheduleMoreWrapperHeight - 40 ) + 'px';
					moreScheduleLink.textContent = window.bonesGlobals.i18n.schedule.more;
				}
			});
		}
	}) ();

	/*** Afficher le iframe quand on clique sur la boîte vidéo de l'accueil **********************************************************************************/
	(function() {
		let previewVideo = document.getElementById('video-preview');

		if( previewVideo !== null && previewVideo !== '' ) {

			previewVideo.addEventListener( 'click', function(event) {
				previewVideo.classList.add('hidden');
			});
		}
	}) ();

	/*** countUp : Statistiques qui montent ******************************************************************/
	// Requiert functions.isInViewport
	// Requiert functions.countDecimals
	// Requiert les variables globales window.countUpNumbers et window.countUpInstances
	// Requiert un code dans le scrollInterval

	(function() {
		countUpNumbers.forEach( function( element, index, iteratedArray ) {
			let endNumber = parseFloat( element.innerHTML );
			let startNumber = Math.max( 0, ( endNumber - 700 ) );
			let nbDecimals = functions.countDecimals( endNumber );
			let duration = 2; // Secondes
			let options = {
				startVal: startNumber,
				decimalPlaces: nbDecimals,
				duration: duration,
				useEasing: true,
				// Générée avec https://inorganik.github.io/countUp.js/
				easingFn: function(t, b, c, d) {
					let ts = (t /= d) * t;
					let tc = ts * t;
					return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
				},
				useGrouping: true,
				separator: window.bonesGlobals.i18n.numbers.thousandSeparator,
				decimal: window.bonesGlobals.i18n.numbers.decimalSeparator,
			};

			countUpInstances.push( new CountUp( element, endNumber, options ) );
		} );
	}) ();

	// Il faut avoir ouvert la page des modalités et conditions avant de pouvoir cocher la case du formulaire d'inscription
	(function() {
		let policyLink = document.getElementById('policy-link');
		let policyInput = document.getElementById('privacy_policy_reg');
		let lockedPolicy = document.getElementById('locked-policy');
		let verifyPolicy = document.getElementById('verify-policy');

		if( policyLink !== null && policyLink !== '' ) {
			policyInput.classList.add('locked');

			policyLink.addEventListener( 'click', function(event) {
				policyInput.classList.remove('locked');
			});

			policyInput.addEventListener( 'click', function(event) {
				if( policyInput.classList.contains('locked') ) {
					policyInput.checked = false;
					lockedPolicy.classList.add('show');
				} else {
					lockedPolicy.classList.remove('show');
				}
			});

			verifyPolicy.addEventListener( 'click', function(event) {
				if( policyInput.classList.contains('locked') ) {
					event.preventDefault();
					policyInput.checked = false;
					lockedPolicy.classList.add('show');
				} else {
					lockedPolicy.classList.remove('show');
				}
			});
		}
	}) ();

	(function() {
		$('.buttontable').on('click', function() {
			$(this).parent().find('.modal').fadeIn(200).addClass('open');
			$('body').css('overflow', 'hidden');
		});

		$('.modal .close').on('click', function() {
			$(this).closest('.modal').fadeOut(200).removeClass('open');
			$('body').css('overflow', 'auto');
		});
	}) ();


	(function() {
		document.querySelectorAll('.button-suppr').forEach( function( thisEl ) {
			thisEl.addEventListener( 'click', function(this_button) {
				// let messageContainer = document.getElementById( 'messages-container' ),
				let post_id = $(this).attr('id'),
					user_id = bonesGlobals.user_id,
					formData = null, xhr;

				// messageContainer.classList.remove('show');

				xhr = new XMLHttpRequest();

				// Gérer les réponses
				xhr.onreadystatechange = function() {
					if( xhr.readyState == 4 ) {
						if( xhr.status == 200 ) {
							let response = JSON.parse( xhr.responseText );

							if( response.status == 'fail' ) {// ya eu une erreur, explique là au user
								// messageContainer.textContent = response.data.message;
								// messageContainer.classList.add('show');

								// that.submitButtons.forEach( function( thisButton ) {
								// 	thisButton.classList.remove('loading');
								// 	thisButton.disabled = false;
								// } );

							} else {// ça fonctionner remove la ligne dans ton tableau
								//document.getElementById('announcement-element').remove();
								var home_url = window.location.origin;

								window.location.href = home_url + '/zone-photographes/message-suppression';
							}
						} else {// ya eu une erreur avec la page direct (genre un 404), mets une erreur générique ça arrivera pas
							// messageContainer.textContent = bonesGlobals.i18n.commonError;
							// messageContainer.classList.add('show');

							that.submitButtons.forEach( function( thisButton ) {
								thisButton.classList.remove('loading');
								thisButton.disabled = false;
							} );
						}
					}
				};

				formData = new FormData();

				formData.append( 'action', 'delete_announcement' );// Nom de ta fonction dans le php
				formData.append( 'user_id', user_id );
				formData.append( 'post_id', post_id );

				xhr.open( "POST", bonesGlobals.ajaxUrl );
				xhr.send( formData );
			} );
		} );
	}) ();

	/*** Gestion des préférence de cookies ***************************************/
	(function() {
		window.acceptedCookies = cookiesBar.getCookie('acceptedCookies');

		if( 'function' == typeof cookiesBar.cookieConsent ) {
			cookiesBar.cookieConsent();
		}
	}) ();

	/*** Activer les liens vers les fiches photographe ***************************************/
	(function() {

		window.linkEnabled = false;
		window.hasToEnableLinks = false;
		window.enableLinksTimeout = false;

		function cleanupEnableLinksTimers() {
			if( window.hasToEnableLinks ) {
				clearInterval( window.hasToEnableLinks );
				window.hasToEnableLinks = false;
			}

			if( window.enableLinksTimeout ) {
				clearTimeout( window.enableLinksTimeout );
				window.enableLinksTimeout = false;
			}
		}

		function tryEnableLinks( checkGap ) {
			window.linkEnabled = functions.enablePhotographsLink( checkGap );

			if( window.linkEnabled === true ) {
				cleanupEnableLinksTimers();
			}

			return window.linkEnabled;
		}

		function scheduleExactEnable() {
			let nowTimestamp = Math.floor( Date.now() / 1000 );
			let delaySeconds = bonesGlobals.subscribing.event_start - nowTimestamp;

			// Déjà rendu.
			if( delaySeconds <= 0 ) {
				tryEnableLinks( false );
				return;
			}

			window.enableLinksTimeout = setTimeout( function() {
				tryEnableLinks( false );
			}, delaySeconds * 1000 );
		}

		if( document.body.classList.contains( 'page-template-page-phorograph-list' ) && bonesGlobals.subscribing.event_start !== undefined ) {

			// 1) Check immédiat
			tryEnableLinks( false );

			// 2) Timeout vers l'instant exact
			if( window.linkEnabled === false ) {
				scheduleExactEnable();
			}

			// 3) Fallback: re-check périodique (au cas où le timeout est throttlé)
			if( window.linkEnabled === false ) {
				window.hasToEnableLinks = setInterval( function() {
					tryEnableLinks( false );
				}, 5000 );
			}

			// 4) Dès que l'onglet redevient actif (throttling), on re-check tout de suite
			document.addEventListener( 'visibilitychange', function() {
				if( document.visibilityState === 'visible' ) {
					tryEnableLinks( false );
				}
			} );

			// 5) iOS/Safari: retour via bfcache
			window.addEventListener( 'pageshow', function() {
				tryEnableLinks( false );
			} );

		}

	}) ();

	// On laisse la page des photographes accessible, mais on va masquer les ways-to-contact jusqu'à ce que ce soit le temps
	// Révéler les moyens de contact à partir de l'heure d'ouverture (sans AJAX)
	(function() {

		window.nubeeContactRevealed = false;
		window.nubeeRevealContactInterval = false;
		window.nubeeRevealContactTimeout = false;

		function cleanupContactRevealTimers() {
			if( window.nubeeRevealContactInterval ) {
				clearInterval( window.nubeeRevealContactInterval );
				window.nubeeRevealContactInterval = false;
			}

			if( window.nubeeRevealContactTimeout ) {
				clearTimeout( window.nubeeRevealContactTimeout );
				window.nubeeRevealContactTimeout = false;
			}
		}

		function revealWaysToContact() {
			let waysToContact = document.getElementById( 'ways-to-contact' );

			if( waysToContact ) {
				waysToContact.classList.remove( 'hidden' );
			}

			window.nubeeContactRevealed = true;
			cleanupContactRevealTimers();
		}

		function tryRevealWaysToContact() {
			let nowTimestamp = Math.floor( Date.now() / 1000 );

			if( bonesGlobals.subscribing && bonesGlobals.subscribing.event_start !== undefined && nowTimestamp >= bonesGlobals.subscribing.event_start ) {
				revealWaysToContact();
			}
		}

		function scheduleExactReveal() {
			let nowTimestamp = Math.floor( Date.now() / 1000 );
			let delaySeconds = bonesGlobals.subscribing.event_start - nowTimestamp;

			if( delaySeconds <= 0 ) {
				revealWaysToContact();
				return;
			}

			window.nubeeRevealContactTimeout = setTimeout( function() {
				revealWaysToContact();
			}, delaySeconds * 1000 );
		}

		if( document.body.classList.contains( 'author' ) && bonesGlobals.subscribing && bonesGlobals.subscribing.event_start !== undefined ) {

			// Par défaut, #ways-to-contact est caché via la classe .hidden dans le HTML.
			// On le révèle seulement au bon moment.
			tryRevealWaysToContact();

			if( window.nubeeContactRevealed === false ) {
				scheduleExactReveal();

				// Fallback si le timeout est throttlé.
				window.nubeeRevealContactInterval = setInterval( function() {
					tryRevealWaysToContact();
				}, 5000 );

				// Quand l'onglet redevient actif, re-check immédiat.
				document.addEventListener( 'visibilitychange', function() {
					if( document.visibilityState === 'visible' ) {
						tryRevealWaysToContact();
					}
				} );

				// iOS/Safari: retour via bfcache.
				window.addEventListener( 'pageshow', function() {
					tryRevealWaysToContact();
				} );
			}
		}

	}) ();

	// Rediriger vers la liste si la page photograph n'est pas encore active
	/* (function (){

		if( document.body.classList.contains( 'author' ) ) {
			let xhr = new XMLHttpRequest(),
				formData = new FormData(),
				waysToContact = document.getElementById( 'ways-to-contact' ),
				remainingPlaces = document.getElementById( 'remaining-places' );

			if( waysToContact !== null ) {

				let waysToContactId = waysToContact.dataset.id;

				waysToContact.textContent = '';
				waysToContact.classList.remove( 'error' );

				if( waysToContactId !== null ) {

					// Gérer les réponses
					xhr.onreadystatechange = function() {
						if( xhr.readyState == 4 ) {
							if( xhr.status == 200 ) {
								let response = JSON.parse( xhr.responseText );

								if( response.success == false ) {// ya eu une erreur, explique là au user

									waysToContact.textContent = response.data.message;
									waysToContact.classList.add( 'error' );

									remainingPlaces.style.opacity = 0;

								} else {

									response.data.block_content.forEach( way => {

										let anchor = document.createElement('a');

										anchor.href = way.url;
										anchor.classList = way.class;
										anchor.target = way.target;

										anchor.textContent = way.text;

										if( way.image_url ) {

											let image = document.createElement('img');

											image.src = way.image_url;
											image.alt = way.image_alt;

											anchor.append( image );

										}

										waysToContact.classList.remove( 'error' );
										waysToContact.append( anchor );
										// anchor.style.opacity = 1;

									});

									remainingPlaces.querySelector('.label').textContent = response.data.available_places;
									remainingPlaces.style.opacity = 1;

								}
							} else {// ya eu une erreur avec la page direct (genre un 404), mettre une erreur générique, ça n'arrivera pas
								waysToContact.textContent = bonesGlobals.i18n.error.common;
								waysToContact.classList.add( 'error' );
							}
						}
					};


					formData.append( 'action', 'photograph_details_enabled' );// Nom de ta fonction dans le php
					formData.append( 'author_id', parseInt( waysToContactId ) );// Nom de ta fonction dans le php

					xhr.open( "POST", bonesGlobals.ajaxUrl );
					xhr.send( formData );
				}
			}
		}

	}) (); */


}) ();